import HighchartsReact from "highcharts-react-official";
import { useLocation } from "react-router-dom";
import Highcharts, { each, setOptions } from "highcharts";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@material-ui/core";
import { SettingsBrightnessSharp } from "@material-ui/icons";
import PropTypes from "prop-types";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import AppContext from "../../context/AppContext";
import { Button } from "@mui/material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const AssetReportDetail = () => {
  const location = useLocation();
  const { asset_name } = useParams();
  const param1 = asset_name;
  const [data, setData] = useState([]);
  const [assetDetails, setAssetDetails] = useState([]);
  const [interval, setInterval] = useState("hour");
  const [gateways, setGateways] = useState("");
  const { gateway } = useContext(AppContext);
  const [distance, setDistance] = useState("rssi");
  const [time, setTimeInterval] = useState("hour");
  const currentDate = new Date();
  const oneDayBefore = new Date(currentDate);
  oneDayBefore.setHours(currentDate.getHours() - 1);
  let localStartTime = new Date(
    oneDayBefore.getTime() - oneDayBefore.getTimezoneOffset() * 60000
  );
  let localEndTime = new Date(
    currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
  );
  const [searchData, setSeearchData] = useState(null);
  const [dateRange, setDateRange] = useState({
    start: localStartTime,
    end: localEndTime,
  });
  const handleChange = (event) => {
    setInterval(event.target.value);
  };
  const handleChangeGateway = (event) => {
    setGateways(event.target.value);
  };

  const handleChangeDistance = (event) => {
    setDistance(event.target.value);
  };
  const handleChangeTimeInterval = (event) => {
    setTimeInterval(event.target.value);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);


  useEffect(() => {
    const fetchData = async () => {
      // const response = await axios.get(`${process.env.REACT_APP_CORE_URL}/api/v1/beacon/asset/find`);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/asset/find`,
          {
            intervals: interval,
            asset_name: param1,
            gateway: gateways,
            distance: distance,
            time: time
          }
        );
        if (response.data.success == true) {
          setData(response.data.data);
          setAssetDetails(response.data.asset_details);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [interval, gateways, distance, time]);

  const options = {
    series: Object.keys(data).map((each) => ({
      name: each,
      data: data[each].map((item) => [
        new Date(item.ts).getTime() +
        5 * 60 * 60 * 1000 +
        30 * 60 * 1000,
        Number(item.rssi),
      ]),
    })),
    chart: {
      type: "scatter",
      zooming: {
        type: "xy",
      },
    },
    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      align: "left",
    },

    xAxis: {
      type: "datetime",
      title: {
        text: "Timestamp",
      },
    },
    yAxis: {
      title: {
        text: distance == "rssi" ? "RSSI" : "Distance",
      },
      labels: {
        format: distance == "rssi" ? "{value}" : "{value} m",
      },
    },
    legend: {
      enabled: true,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 2.5,
          symbol: "circle",
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        },
        jitter: {
          x: 0.005,
        },
      },
      setOptions: {
        colors: [
          "rgba(5,141,199,0.5)",
          "rgba(80,180,50,0.5)",
          "rgba(237,86,27,0.5)",
        ],
      },
    },
    tooltip: {
      formatter: function () {
        let valueLabel;
        if (distance === "rssi") {
          valueLabel = `RSSI: ${this.y}`;
        } else {
          valueLabel = `Distance: ${this.y} m`;
        }
        return `<b>${this.series.name
          }</b><br/>Timestamp: ${Highcharts.dateFormat(
            "%Y-%m-%d %H:%M:%S",
            this.x
          )}<br/>${valueLabel}`;
      },
    },
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [value, setValue] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const columns = [
    {
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "rssi",
      headerName: "MAC ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"RSSI "}</strong>
      ),
    },
    {
      field: "ts",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Timestamp "}</strong>
      ),
    },
    {
      field: "device_id",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Gateway Imei "}</strong>
      ),
    },
    {
      field: "battery",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Battery "}</strong>
      ),
    },
    // {
    //   field: "temperature",
    //   headerName: "Timestamp",
    //   width: 200,
    //   headerAlign: "center",
    //   align: "center",
    //   renderHeader: () => (
    //     <strong style={{ color: "rgb(28, 70, 146)" }}>{"Temperature "}</strong>
    //   ),
    // },
    // {
    //   field: "humidity",
    //   headerName: "Timestamp",
    //   width: 200,
    //   headerAlign: "center",
    //   align: "center",
    //   renderHeader: () => (
    //     <strong style={{ color: "rgb(28, 70, 146)" }}>{"Humidity "}</strong>
    //   ),
    // },
  ];

  const options1 = {
    title: {
      text: "Assets Tracker",
    },
    xAxis: {
      type: "datetime",
      title: {
        text: "Timestamp",
      },
    },
    yAxis: {
      title: {
        text: "Gateway",
      },
    },
    chart: {
      height: 350, // Adjust the height of the chart as per your requirement
    },

    series: searchData,

    tooltip: {
      formatter: function () {
        return `<b>${this.series.name
          }</b><br/>Timestamp: ${Highcharts.dateFormat(
            "%Y-%m-%d %H:%M:%S",
            this.x
          )}<br/>No: ${this.y}`;
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 6,
        },
        turboThreshold: 100000,
      },
    },
  };

  // function subtractTime(inputTime, hours, minutes) {
  //   let [datePart, timePart] = inputTime.split(" ");

  //   let [hoursStr, minutesStr, secondsStr] = timePart.split(":").map(Number);

  //   hoursStr -= hours;
  //   minutesStr -= minutes;

  //   if (minutesStr < 0) {
  //     minutesStr += 60;
  //     hoursStr--;
  //   }
  //   if (hoursStr < 0) {
  //     hoursStr += 24;
  //   }

  //   let updatedTime = `${hoursStr.toString().padStart(2, "0")}:${minutesStr
  //     .toString()
  //     .padStart(2, "0")}:${secondsStr}`;

  //   return `${datePart} ${updatedTime}`;
  // }

  useEffect(() => {
    const fetchData = async () => {
      try {
        let formattedStartTime = dateRange.start
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        let formattedEndTime = dateRange.end
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        // formattedStartTime = subtractTime(formattedStartTime, 5, 30);
        // formattedEndTime = subtractTime(formattedEndTime, 5, 30);

        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/asset/tracking`,
          {
            asset_id: param1,
            start_time: formattedStartTime,
            end_time: formattedEndTime,
          }
        );

        const groupedData = response.data.timestamps.reduce((acc, entry) => {
          if (!acc[entry.location_position]) {
            acc[entry.location_position] = [];
          }
          acc[entry.location_position].push({
            x:
              new Date(entry.timestamp).getTime() +
              5 * 60 * 60 * 1000 +
              30 * 60 * 1000,
            y: 1,
          });

          return acc;
        }, {});

        const seriesData = Object.entries(groupedData).map(
          ([gateway, data]) => ({
            name: gateway,
            data: data,
          })
        );




        seriesData.forEach((obj, index) => {
          obj.data.forEach((dataPoint) => {
            dataPoint.y = index + 1;
          });
        });

        setSeearchData(seriesData);
      } catch (error) {
        console.error("Error fetching asset details:", error);
      }
    };

    fetchData();
  }, [dateRange]);

  return (
    <Grid container>
      <Grid
        container
        style={{
          boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.2)",
          borderRadius: 13,
          padding: 25,
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        {/* <Grid
          item
          xs={2}
          style={{
            fontFamily: "sans-serif",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            style={{ width: 80, height: 80 }}
            src={
              assetDetails.asset_category == "Bag"
                ? "/images/Bag.png"
                : assetDetails.asset_category == "Trolley"
                ? "/images/Trolley.png"
                : "/images/Laptop.png"
            }
          />
          <Typography
            style={{ fontWeight: 500, fontSize: "14px", color: "#60636C" }}
          >
            Asset Category:{" "}
            <span
              style={{ fontWeight: 500, color: "#1976d2", fontSize: "15px" }}
            >
              {assetDetails.asset_category}
            </span>
          </Typography>
        </Grid> */}
        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: isMobile ? "flex-start" : "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
            }}
          >
            Asset Category:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {assetDetails.asset_category}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: isMobile ? "flex-start" : "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
            }}
          >
            Asset Name:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {assetDetails.asset_name}
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12} md={2}
          style={{ color: "#1976d2", fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}
        >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: isMobile ? "flex-start" : "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
            }}
          >
            Asset Creation Time:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {new Date(assetDetails.asset_creation_time).toLocaleString()}
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={12} md={2} style={{ fontFamily: "sans-serif", textAlign: isMobile ? "left" : "center" }}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: "14px",
              alignItems: "center",
              justifyContent: isMobile ? "flex-start" : "center",
              display: "flex",
              flexDirection: isMobile ? "row" : "column",
              color: "#60636C",
            }}
          >
            Asset Mac:{" "}
            <Typography
              style={{
                fontWeight: 500,
                fontSize: "14px",
                color: "#1976d2",
                padding: "10px 0px",
                paddingLeft: isMobile ? "1rem" : "",
                fontSize: "15px",
              }}
            >
              {assetDetails.asset_mac}
            </Typography>
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ width: "100%", marginTop: 30 }}>
          <Box>
            <Tabs
              value={value}
              onChange={handleChangeTab}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#07689f",
                },
              }}
            >
              <Tab label="Visualisation" {...a11yProps(0)} />
              <Tab label="Logs" {...a11yProps(1)} />
              <Tab label="Connected To Gateways" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Grid container spacing={2} style={{ marginTop: 25 }}>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Interval Size
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={interval}
                    label="Interval Size"
                    style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                    onChange={handleChange}
                  >
                    <MenuItem value="second">second</MenuItem>
                    <MenuItem value="minute">minutes</MenuItem>
                    <MenuItem value="hour">hour</MenuItem>
                    <MenuItem value="day">day</MenuItem>
                    <MenuItem value="week">week</MenuItem>
                    <MenuItem value="month">month</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gateway</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Interval Size"
                    style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                    onChange={handleChangeGateway}
                  >
                    {gateway &&
                      gateway.map((each, index) => {
                        return (
                          <MenuItem key={index} value={each.mac_address}>
                            {each.position}({each.mac_address})
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
              {/* <Grid item xs={3}>
                <FormControl>
                  <InputLabel id="demo-simple-select-label">
                    Distance
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Distance"
                    value={distance}
                    style={{ width: 200, marginBottom: 40 }}
                    onChange={handleChangeDistance}
                  >
                    <MenuItem value="rssi">RSSI</MenuItem>
                    <MenuItem value="metre">Metre</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Time Interval
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Time Interval"
                    value={time}
                    style={{ width: isMobile ? "100%" : 200, marginBottom: isMobile ? "0.5rem" : 40 }}
                    onChange={handleChangeTimeInterval}
                  >
                    <MenuItem value="hour">Last 1 Hour</MenuItem>
                    <MenuItem value="2hour">Last 2 Hour</MenuItem>
                    <MenuItem value="3hour">Last 3 Hour</MenuItem>
                    <MenuItem value="4hour">Last 4 Hour</MenuItem>
                    <MenuItem value="6Month">Last 6 Month</MenuItem>
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="yesterday">Yesterday</MenuItem>
                    <MenuItem value="week">Last Week</MenuItem>
                    <MenuItem value="all">All</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                {Object.keys(data).length > 0 ? (
                  <HighchartsReact highcharts={Highcharts} options={options} />
                ) : (
                  <p>No data available</p>
                )}
              </Grid>
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Grid item xs={12} style={{ height: 500, marginTop: 25 }}>
              <DataGrid
                getRowId={(row) => row.ts}
                rows={data[param1]}
                columns={columns}
                rowSelection={false}
                pageSize={10}
                rowsPerPageOptions={[10, 20, 30]}
                density="compact"
                components={{
                  Toolbar: GridToolbar,
                  FilterPanel: GridFilterPanel,
                }}
                slotProps={{
                  filterPanel: {
                    sx: {
                      width: "100%",          // full width responsive
                      maxWidth: "100%",
                      padding: "10px",
                      "& .MuiDataGrid-filterForm": {
                        flexDirection: "column",
                        gap: "10px",
                      },
                    },
                  },
                }}
                pagination
              />
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Grid item xs={12} style={{ marginTop: 25 }}>
              <TextField
                label="Start Time"
                type="datetime-local"
                value={dateRange.start.toISOString().slice(0, 16)}
                onChange={
                  (e) => {
                    let currentTime = new Date(e.target.value);
                    let localTime = new Date(
                      currentTime.getTime() -
                      currentTime.getTimezoneOffset() * 60000
                    );
                    setDateRange({ ...dateRange, start: localTime });
                  }
                  // setDateRange({ ...dateRange, start: new Date(e.target.value) })
                }
                InputLabelProps={{
                  shrink: true,
                  style: {
                    fontWeight: 700,
                    color: "#005778",
                    fontSize: 15,
                  },
                }}
                InputProps={{
                  style: {
                    fontSize: 14,
                    color: "rgba( 0, 0, 0, 70% )",
                    height: 40,
                  },
                }}
                style={{ width: isMobile ? "100%" : "40%", marginRight: 30, marginBottom: 30 }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#50C1E9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#50C1E9",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#50C1E9",
                    },
                  },
                }}
              />
              <TextField
                label="End Time"
                type="datetime-local"
                value={dateRange.end.toISOString().slice(0, 16)}
                onChange={
                  (e) => {
                    let currentTime = new Date(e.target.value);
                    let localTime = new Date(
                      currentTime.getTime() -
                      currentTime.getTimezoneOffset() * 60000
                    );
                    setDateRange({ ...dateRange, end: localTime });
                  }
                  // setDateRange({ ...dateRange, end: new Date(e.target.value) })
                }
                InputLabelProps={{
                  shrink: true,
                  style: {
                    fontWeight: 700,
                    color: "#005778",
                    fontSize: 15,
                  },
                }}
                InputProps={{
                  style: {
                    fontSize: 14,
                    color: "rgba( 0, 0, 0, 70% )",
                    height: 40,
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#50C1E9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#50C1E9",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#50C1E9",
                    },
                  },
                }}
                style={{ width: isMobile ? "100%" : "40%", marginRight: 30 }}
              />

              {searchData ? (
                <HighchartsReact highcharts={Highcharts} options={options1} />
              ) : (
                <p>No data available</p>
              )}
            </Grid>
          </CustomTabPanel>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AssetReportDetail;
